import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminModule } from './pages/admin/admin.module';
import { FormsModule } from '@angular/forms'
import { SharedModule } from './shared/shared.module';
import { UserModule } from './pages/user/user.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './interceptors/interceptor.service';
import { ShopingCartComponent } from './shared/shoping-cart/shoping-cart.component';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
//import { AppConfigService } from './service/index.service';

/*
export function initApp(appConfig: AppConfigService) {
   return () => appConfig.cargarConfig();
}
*/
@NgModule({
   declarations: [
      AppComponent,
      ShopingCartComponent
   ],
   imports: [
      BrowserModule,
      CommonModule,
      SharedModule,
      AdminModule,
      UserModule,
      NgbAccordionModule,
      AppRoutingModule,
      FormsModule,
   ],
   providers: [
      { provide: LocationStrategy, useClass: HashLocationStrategy },
      {
         provide: HTTP_INTERCEPTORS,
         useClass: InterceptorService,
         multi: true,
      },
      /*
      {
         provide: APP_INITIALIZER,
         useFactory: initApp,
         deps: [AppConfigService],
         multi: true
      }
         */
   ],
   bootstrap: [
      AppComponent
   ],
   exports: [

   ],
   schemas: [
      CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA
   ],
})
export class AppModule { }
